/**
 * EQuIP APC Dashboard Page
 *
 * Page shell for the supervising physician APC dashboard.
 * Visible to equip.read users who supervise APCs (has_apc_supervision === true).
 *
 * Role behavior:
 * - equip.read physician with APC mappings: full APC performance view
 * - Any user without APC supervision mappings: informational empty state
 */

import { APCDashboard } from './apc-dashboard/APCDashboard'

export function EquipAPCDashboardPage() {
  return <APCDashboard />
}
